import { TpoCertificationPaths } from 'app/configs/routesConfig/tpoCertification';

import { PATH_LOGIN } from 'constants/authPaths';
import { LS_TPO_CERT_SIGNUP_HOST } from 'constants/localStorage';
import { logger } from 'utils/logger';

/* Persist the TPO-signup host the cert wizard runs against, so a later session timeout on the
   AdminPanel cert surface can bounce the passwordless partner back to that host's OTP login
   (they have no AdminPanel password, so the afr password login is unusable). The host is the origin
   of the cert page's `iframeBaseUrl` — resolved server-side from the sub-company's default signup
   domain, not from any client-influenced input. Only an https origin is stored (the resume target
   feeds window.location). */
export const setTpoCertSignupHost = baseUrl => {
  try {
    const { origin, protocol } = new URL(baseUrl);

    if (protocol === 'https:') {
      localStorage.setItem(LS_TPO_CERT_SIGNUP_HOST, origin);
    }
  } catch (error) {
    logger.info('setTpoCertSignupHost: could not parse iframe base URL', error);
  }
};

export const clearTpoCertSignupHost = () => localStorage.removeItem(LS_TPO_CERT_SIGNUP_HOST);

/* Returns the returning-user OTP login URL on the captured signup host, or null when no host was
   captured (the caller then falls back to the default post-logout redirect). */
export const getTpoCertResumeLoginUrl = () => {
  const signupOrigin = localStorage.getItem(LS_TPO_CERT_SIGNUP_HOST);

  return signupOrigin ? `${signupOrigin}${PATH_LOGIN}` : null;
};

export const isTpoCertPathname = pathname =>
  pathname.startsWith(TpoCertificationPaths.tpoCertification.path);
